import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Tab, Tabs } from '@material-ui/core';
import MainLayoutStyle from '../../styles/MainLayoutStyle';

const RightTabLists = (props) => {
  const classes = MainLayoutStyle();

  const dealershipCustomGroups = useSelector((state) => state.getCustomGroupsForDealership?.dealershipCustomGroups);

  const showCustomGroups = useMemo(() => !!dealershipCustomGroups?.length, [dealershipCustomGroups]);

  return (
    <div className={classes.rightbar1}>
      <div className={classes.menuListCG}>
        <Tabs
          value={props.menuValue}
          onChange={(event, newValue) => props.setMenuValue(newValue)}
          aria-label="simple tabs example"
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          style={{ width: '100%' }}
        >
          <Tab label="Departments" style={{ minWidth: showCustomGroups ? '50%' : '100%' }} />
          {showCustomGroups && <Tab label="Custom Groups" style={{ minWidth: '50%' }} />}
        </Tabs>
      </div>
    </div>
  );
};

export default RightTabLists;
